import { ScreeningPscInspection } from "../../types/Screening";
import dayjs from "dayjs";

export const ScreeningPscInspectedBody = (item: ScreeningPscInspection) => {
    const date = dayjs(item.date * 1000).format("DD/MM/YYYY");

    return <p>{date}</p>;
};
